import { setItem } from './storage';

export const refreshToken = (newToken: string) => {
  setItem('token', newToken);
};